import React from "react";

// eslint-disable-next-line react/display-name
export default () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5.5" y="4" width="5" height="16" rx="2.5" fill="#E66525" />
    <rect x="13.5" y="4" width="5" height="16" rx="2.5" fill="#E66525" />
  </svg>
);
